import React from 'react';
import {Col, ControlLabel, Form, FormControl, FormGroup, Row} from "react-bootstrap";

class AssetHistoryForm extends React.Component {
    handleChange = (e) => {
        const {name, value} = e.target;
        this.props.updateHistoryAttribute(name, value);
    };

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.submitPlantStatsHistory();
    };

    render() {
        const {assetHistory, cancelHistoryEdit} = this.props;

        return (
            <Form onSubmit={this.handleSubmit}>
                <Row>
                    <Col md={4}>
                        <FormGroup bsSize="small">
                            <ControlLabel>Date</ControlLabel>
                            <FormControl
                                name="review_date"
                                type="date"
                                value={assetHistory.review_date ? assetHistory.review_date.substring(0, 10) : ''}
                                onChange={this.handleChange}
                            />
                        </FormGroup>
                    </Col>
                    <Col md={4}>
                        <FormGroup bsSize="small">
                            <ControlLabel>DBH</ControlLabel>
                            <FormControl
                                name="dbh"
                                type="number"
                                pattern="\d*"
                                inputMode="decimal"
                                placeholder="DBH"
                                value={assetHistory.dbh || ''}
                                onChange={this.handleChange}
                            />
                        </FormGroup>
                    </Col>
                    <Col md={4}>
                        <FormGroup bsSize="small">
                            <ControlLabel>Height</ControlLabel>
                            <FormControl
                                name="height"
                                type="number"
                                pattern="\d*"
                                inputMode="decimal"
                                placeholder="Height"
                                value={assetHistory.height || ''}
                                onChange={this.handleChange}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col md={4}>
                        <FormGroup bsSize="small">
                            <ControlLabel>Spread</ControlLabel>
                            <FormControl
                                name="width"
                                type="number"
                                pattern="\d*"
                                inputMode="decimal"
                                placeholder="Spread"
                                value={assetHistory.width || ''}
                                onChange={this.handleChange}
                            />
                        </FormGroup>
                    </Col>
                    <Col md={4}>
                        <FormGroup bsSize="small">
                            <ControlLabel>Stems</ControlLabel>
                            <FormControl
                                name="stem_count"
                                type="number"
                                pattern="\d*"
                                inputMode="decimal"
                                placeholder="Stem Count"
                                value={assetHistory.stem_count || ''}
                                onChange={this.handleChange}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col md={12} className="justify-flex-end flex-gap-10">
                        <button type="submit" className="btn btn-success btn-sm margin-left-auto">Save</button>{' '}
                        <button type="button" className="btn btn-danger btn-sm" onClick={cancelHistoryEdit}>Cancel</button>
                    </Col>
                </Row>
            </Form>
        );
    }
}

export default AssetHistoryForm;
